
import React, { Component } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import RefundInActiveRequestForm from './refundInActiveRequestsForm';
import { getUserByPhoneApi } from '../../utils/apisConsts';

class RefundInActiveRequest extends Component{
    state = {
        componentSteps: [
            {
                title: 'Get User Transactions',
                content: <GetInfo apiLink={getUserByPhoneApi} />,
                id: 0,
            }, {
                title: 'Refund In-Active Requests',
                content: <RefundInActiveRequestForm />,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        )
    }
}

export default RefundInActiveRequest
